import styled, { css } from "styled-components"
import { lighten } from "polished"
import { P } from "../typography"

export const Data = styled.div`
  display: grid;
  gap: 2rem;
  grid-auto-flow: column;
  justify-content: start;
`

export const Datum = styled.div``

export const Key = styled(P).attrs({
  marginless: true,
  size: "small",
  color: "primary"
})`
  margin-bottom: 0.25rem;
`

export const Value = styled(P).attrs({
  marginless: true,
  bold: true
})`
  display: inline-block;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

  ${(props) =>
    !!props.negative &&
    css`
      background-color: ${props.theme.colors.danger};
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      border-radius: 0.5rem;
    `}

  ${(props) =>
    !!props.altNegative &&
    css`
      background-color: ${lighten(0.15, props.theme.colors.danger)};
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      border-radius: 0.5rem;
    `}

  ${(props) =>
    !!props.positive &&
    css`
      background-color: ${props.theme.colors.success};
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      border-radius: 0.5rem;
    `}
`
